import { Component } from '@angular/core';

@Component({
  selector: 'dish-footer',
  templateUrl: './dish-footer.component.html',
  styleUrls: ['./dish-footer.component.scss'],
  standalone: false,
})
export class DishFooterComponent {}
